module.exports = __webpack_public_path__ + "static/media/Slice6@2x.e8123722.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice6@2x.png
// module id = 1435
// module chunks = 0